import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';
import { ERROR_CODES, ERROR_SEVERITY, ErrorDCR, PacErrorDCR } from '@ddt-web/config';
import * as get from 'lodash/get';

import { ErrorObject, PopupDialogAction, PopupDialogActionOptions } from '../models';
import { AbstractErrorHandlerService } from './abstract-error-handler.service';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable()
export class BpasEngagementsErrorHandlerService extends AbstractErrorHandlerService {
	protected trackErrorMessage: string;

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		super(contentService, errorPopupService, tealiumAnalyticsService, errorHelperService);
	}

	public handleError(error): void {
		if (error instanceof ErrorObject) {
			const errorDetails = get(error, 'responseJson.errorCode');
			const configName = get(error, 'configName');

			if (configName === ERROR_CODES.PAC_ERROR_CODES.ENGAGEMENT_CONFIG_NAME && ErrorDCR[errorDetails.message]) {
				this.createRetryErrorDialog(errorDetails.message, errorDetails.trackMsg);
			} else {
				this.nextHandler.handleError(error);
			}
		} else {
			this.nextHandler.handleError(error);
		}
	}

	private createRetryErrorDialog(errorMessageContent: string, trackErrorMessage: string): void {
		this.errorMessage = this.contentService.get('SOMETHING_WENT_WRONG', 'Something went wrong');
		this.errorSeverity = ERROR_SEVERITY.CRITICAL;

		this.tealiumAnalyticsService.trackError(trackErrorMessage, this.errorSeverity);

		const dialogErrorMessage = this.buildErrorMessage();
		dialogErrorMessage.actions = [PopupDialogAction.create({
			label: this.contentService.get('PAC_RETRY_MESSAGE', PacErrorDCR.PAC_RETRY_LABEL),
			description: this.contentService.get(errorMessageContent, ErrorDCR[errorMessageContent]),
			reload: true
		} as PopupDialogActionOptions)];

		this.errorPopupService.openResponseMessageDialog(dialogErrorMessage, true);
	}
}
